import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

const Sidebar = () => {
  const navigate = useNavigate();
   const [profile, setProfile] = useState(null);
   useEffect(() => {
      const storedUser = localStorage.getItem("user");
  
      // 🚫 Redirect if not logged in
      if (!storedUser) {
        navigate("/login");
        return;
      }
  
      // ✅ Load user from localStorage
      const userData = JSON.parse(storedUser);
      setProfile(userData);
    }, [navigate]);
  return (
    <div
     className="user_sidebar"
    >
      <h3 className="Dashboard">Dashboard</h3>

      <ul className='sidelist' style={{ listStyle: "none", padding: 0, marginTop: "15px" }}>
        <li style={{ marginBottom: "12px", cursor: "pointer" }}><a href="/profile">Profile</a></li>
        <li style={{ marginBottom: "12px", cursor: "pointer" }}><a href="/booking">Bookings</a></li>
         <li  onClick={() => {
                  localStorage.removeItem("user");
                  navigate("/login");
                }} style={{ marginBottom: "12px", cursor: "pointer" }}>Logout</li>
         
        
      </ul>
    </div>
  );
};

export default Sidebar;
